import HttpService from 'services/HttpService';
import { ACCOUNT_BASE_PATH } from 'vue/constants/svodRoutes';
export default class ProfileService {
    constructor() {
        this.paths = {
            getUser: '/user-profile/xhr/user/',
            whosWatching: '/user-profile/xhr/whos-watching/',
            createProfile: '/user-profile/xhr/create-profile/',
            deleteProfile: '/user-profile/xhr/delete-profile/',
            updateProfile: '/user-profile/xhr/update-profile/',
            ratingsData: '/user-profile/xhr/ratings/',
            getAvailableAvatars: '/user-profile/xhr/available-avatars/',
            getAvailableGroupAvatars: '/user-profile/xhr/available-group-avatars/',
            verifyPinControl: '/user-profile/xhr/verify-pin/',
            createPin: `${ACCOUNT_BASE_PATH}xhr/create-pin/`,
            relogin: `${ACCOUNT_BASE_PATH}xhr/parental-relogin/`,
            disableKidsButton: `/user-profile/xhr/disable-kids-button/`,
        };

        this.http = new HttpService();
        this.http.regionBaseUrl = CBS.Registry.region.prefix;
    }

    disableKidsButton() {
        return new Promise((resolve, reject) => {
            this.http
                .doPost(this.paths.disableKidsButton, {})
                .then((res) => {
                    if (res.success) {
                        resolve(res.data);
                    } else {
                        reject(res);
                    }
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    syncProfilesAndParentalControls(fetch = true) {
        return new Promise((resolve, reject) => {
            this.http
                .doGet(this.paths.getUser, {
                    fetch: fetch,
                })
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    parentalRelogin(payload = null) {
        return new Promise((resolve, reject) => {
            if (!payload.password) reject(null);
            this.http
                .doPost(this.paths.relogin, payload)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    getRatingsData() {
        return new Promise((resolve, reject) => {
            this.http
                .doGet(this.paths.ratingsData)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    getAvailableAvatars() {
        return new Promise((resolve, reject) => {
            this.http
                .doGet(this.paths.getAvailableAvatars)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    getAvailableGroupAvatars(payload) {
        let path = this.paths.getAvailableGroupAvatars + payload.userProfileType + '/';
        return new Promise((resolve, reject) => {
            this.http
                .doGet(path)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    whosWatching(payload) {
        return new Promise((resolve, reject) => {
            this.http
                .doPost(this.paths.whosWatching, payload)
                .then((res) => {
                    if (res.success) {
                        // TODO: handle this in HttpService
                        resolve(res.data);
                    } else {
                        reject(res);
                    }
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    createProfile(payload) {
        return new Promise((resolve, reject) => {
            this.http
                .doPost(this.paths.createProfile, payload)
                .then((res) => {
                    if (res.success) {
                        resolve(res.data);
                    } else {
                        reject(res);
                    }
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    updateProfile(payload) {
        return new Promise((resolve, reject) => {
            this.http
                .doPost(this.paths.updateProfile, payload)
                .then((val) => {
                    if (val.success) {
                        // TODO: handle this in HttpService
                        resolve(val.data);
                    } else {
                        reject(val);
                    }
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    createPin(payload) {
        return new Promise((resolve, reject) => {
            this.http
                .doPost(this.paths.createPin, payload)
                .then((val) => {
                    resolve(val);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    deleteProfile(payload) {
        return new Promise((resolve, reject) => {
            this.http
                .doPost(this.paths.deleteProfile, payload)
                .then((res) => {
                    if (res.success) {
                        // TODO: handle this in HttpService
                        resolve(res.data);
                    } else {
                        reject(res);
                    }
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    verifyPinControl(payload) {
        return new Promise((resolve, reject) => {
            this.http
                .doPost(this.paths.verifyPinControl, payload)
                .then((res) => {
                    if (res.success) {
                        resolve(res.data);
                    } else {
                        reject(res);
                    }
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
}
